import { Action } from "@ngrx/store";

export enum CustomerActionTypes {
	AddressesLoaded = "[Customer Effects] Addresses Loaded"
}

export class AddressesLoaded implements Action {
	readonly type = CustomerActionTypes.AddressesLoaded;
	constructor(public payload) {}
}

export type CustomerActions = AddressesLoaded;
